const icons = {
  default: {
    height: `icon`,
    width: `icon`,
  },
}

export default icons
